import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, ModalBody, ModalFoot } from '@dixa/lib-shared-habla';
import { Field, Form, reduxForm } from 'redux-form';
import { validateName } from 'utils/formValidator';
import { FORM_NAME, validateEditFormStep1 } from '../utils/editAutomationForm';
import styles from './editAutomationForm.module.scss';
const EditAutomationFormStep1Impl = (props) => {
    const { handleSubmit, handleCancel, confirmName, pristine } = props;
    return (_jsxs(Form, Object.assign({ onSubmit: handleSubmit(props.nextStep) }, { children: [_jsxs(ModalBody, { children: [_jsx(Field, { label: "Name", name: "name", maxLength: "255", component: FieldText, type: "text", className: styles.field, placeholder: "Automation", required: true, validate: validateName }), _jsx(Field, { label: "Description", name: "description", component: FieldText, className: styles.field, placeholder: "What does this automation do? (optional)" })] }), _jsx(ModalFoot, { cancelOnClick: handleCancel, cancelName: "Cancel", confirmOnClick: handleSubmit(props.nextStep), confirmName: confirmName, confirmProps: {
                    disabled: pristine,
                } })] })));
};
export const EditAutomationFormStep1 = reduxForm({
    form: FORM_NAME,
    enableReinitialize: false,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate: validateEditFormStep1,
})(EditAutomationFormStep1Impl);
